module.exports = __webpack_public_path__ + "static/media/3ll15.6bec52e2.png";